/** Draft, pending or archived stickers stay in a collection but collectors can't open them. */
export default function isStickerUnavailable(
  sticker?: { status?: string | null } | null,
): boolean {
  return Boolean(sticker?.status) && sticker?.status !== 'Active';
}

/** Same wording as redeemStickerCollectionCode: Draft/Pending were never live, the rest ended. */
export function unavailableStickerText(sticker?: { status?: string | null } | null): string {
  return sticker?.status === 'Draft' || sticker?.status === 'Pending'
    ? "This sticker isn't available yet."
    : 'This sticker is no longer available.';
}
